import NotificationsTableV2 from './NotificationsTableV2'

export default NotificationsTableV2